import styled from '@emotion/styled'
import { Button, Steps } from 'components/patterns'
import { DrawerRow } from 'components/patterns/Drawer/Drawer.style'
import { Col, withFlex, Row } from 'components/patterns/Layout'

import { themeColor } from 'utils/styles'

export const HeaderStyled = styled.div`
  border-bottom: 4px solid ${themeColor('blueSecondary')};
  .ant-alert {
    padding: 8px 8px 8px 46px;
    button {
      top: 0;
    }
    .ant-alert-description p {
      margin-top: 0;
      padding-top: 1px;
    }
  }
`

export const FooterStyled = styled(DrawerRow)`
  width: 100%;
  border-top: 1px solid ${themeColor('basicBoxBorderColor')};
  margin-top: 10px;
  background: ${themeColor('basicBoxBackgroundColor')};
  text-align: center;
  position: fixed;
  bottom: 0;
`.withComponent('footer')

export const FooterColumn = styled(withFlex(Col))`
  ${Button} {
    margin: 16px 8px !important;
  }
`

export const StepperRow = styled(withFlex(Row))`
  padding: 32px 16px;
`

export const StepperLabelCol = withFlex(Col)

export const StyledSteps = styled(Steps)`
  .ant-steps-item.ant-steps-item-process.ant-steps-item-active
    .ant-steps-item-content {
    font-size: 20px;

    .ant-steps-item-title {
      color: ${themeColor('blueSecondary')};
    }
  }
`

export const BatchImportContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 32px;
  overflow-y: auto;
  margin-bottom: 61px;

  .ant-table {
    width: 80%;
    min-width: 860px;
  }
`
